import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { UserModel } from '../../../models/user.model'
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { UserResponse } from '../../../models/user-response'
import { Observable } from 'rxjs/Observable'
import { DocumentModel } from '../models/document-model'
import { MatSort, PageEvent, Sort } from '@angular/material'
import { DocumentsResponseModel } from '../models/documents-response.model'

@Injectable()
export class AdminDocumentsService {
  private readonly url = environment.base_url + '/v1/administration'
  private filters: any

  documents: DocumentModel[]
  user: DocumentModel

  onDocumentsChanged: BehaviorSubject<any> = new BehaviorSubject(DocumentsResponseModel)
  onDocumentChanged: BehaviorSubject<any> = new BehaviorSubject(undefined)
  onFilterChanged: BehaviorSubject<any> = new BehaviorSubject('')

  constructor(private http: HttpClient) {
    this.documents = []
    this.filters = {
      paginated: true,
    }
  }

  /**
   *
   * @param {number} administrationId
   * @returns {Observable<any>}
   */
  public list(administrationId: number): Observable<DocumentsResponseModel> {
    return this.http
      .get<DocumentsResponseModel>(`${this.url}/${administrationId}/document`, { params: this.filters })
      .map(response => {
        return new DocumentsResponseModel(response)
      })
  }

  /**
   * Delete a document
   * @param {DocumentModel} document
   * @returns {Observable<UserModel>}
   */
  public delete(document: DocumentModel): Observable<UserModel> {
    return this.http.delete<UserModel>(`${this.url}/document/${document.id}`)
  }

  changeSearch(search: string) {
    this.filters.search = search
    this.onFilterChanged.next(this.filters)
  }

  changeFilter(event?: PageEvent) {
    this.filters.page = event.pageIndex + 1
    this.filters.limit = event.pageSize
    this.onFilterChanged.next(this.filters)
  }

  changeSort(event?: MatSort) {
    this.filters.sort = event.active
    this.filters.direction = event.direction
    this.onFilterChanged.next(this.filters)
  }

  /**
   *
   * @param {DocumentModel} document
   */
  setCurrentDocument(document: DocumentModel) {
    this.onDocumentChanged.next(document)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/services/admin-documents.service.ts